import { debounceTime, switchMap } from 'rxjs/operators';
import { BehaviorSubject, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SocketService } from './socket.service';

@Injectable({
  providedIn: 'root'
})
export class BatchService {
  addToBatch = new BehaviorSubject<any[]>([]);
  constructor(private service: SocketService, private toast: ToastrService) {
    service.loading_enabled = false;
    this.addToBatch
      .pipe(
        debounceTime(1000),
        switchMap((resp: any) => {
          if (resp && resp.length) {
            return this.service.create('batch', {
              calls: resp
            });
          } else {
            return of([]);
          }
        })
      )
      .subscribe((resp: any) => {
        if (resp && resp.length) {
          this.toast.success(`List order has been updated`, 'Updated');
          this.addToBatch.next([]);
        }
      });
  }
}
